// extracted by mini-css-extract-plugin
module.exports = {"main":"TraitScore_main__v0VLG","selected":"TraitScore_selected___wPuD","unselected":"TraitScore_unselected___jfV3"};